import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6d9w5m3rqy: FaireBrandEntity = {
  token: "b_6d9w5m3rqy",
  type: "brand",
  name: "land of petite",
  avatarUrl:
    "https://cdn.faire.com/fastly/131afbf89e19c2d586ca15b10e02a66b0f1a86d612f652d1a677434d001fcf98.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dec66d6e54a06eae924a989e60d4cbc58709177f0d8e6d9548896b92e174fdbe.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/131afbf89e19c2d586ca15b10e02a66b0f1a86d612f652d1a677434d001fcf98.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dec66d6e54a06eae924a989e60d4cbc58709177f0d8e6d9548896b92e174fdbe.jpeg",
  location: "92075, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 36,
  isTopShop: true,
  isInsider: true,
  description:
    "Land of Petite was created with a heartfelt mission: to offer the finest in modern, safe baby and toddler essentials, educational items, and clothing. Born from Lindsey’s passion for thoughtful design and purposeful products, every item is carefully researched and created to be both practical and adorable. Whether you're a parent, boutique owner, or gift-giver, Land of Petite pieces are designed to be beautiful, functional additions to any home or shop.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:38.969Z",
    importedBy: "entity-db-cli",
  },
};
